import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { FaLinkedinIn } from "react-icons/fa";
import { FormattedMessage } from "react-intl";
import "bootstrap/dist/css/bootstrap.min.css";
import es from "./imagenes/argentina.png";
import en from "./imagenes/united-states.png";
import { langContext } from "./contexto/langContext";

function Cerrado() {
  const idioma = useContext(langContext);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0d1117",
        color: "#c9d1d9",
        textAlign: "center",
        padding: "1rem",
      }}
    >
      <div style={{ maxWidth: "600px", width: "100%" }}>
        {/* Selector de idioma */}
        <div
          style={{
            marginBottom: "1.5rem",
            display: "flex",
            justifyContent: "center",
            gap: "0.75rem",
          }}
        >
          <button
            onClick={() => idioma.establecerLenguaje("es-AR")}
            style={{ background: "none", border: "none", padding: 0 }}
          >
            <img src={es} alt="Español" width={42} />
          </button>
          <button
            onClick={() => idioma.establecerLenguaje("en-US")}
            style={{ background: "none", border: "none", padding: 0 }}
          >
            <img src={en} alt="English" width={42} />
          </button>
        </div>

        <h1
          style={{
            fontSize: "clamp(2.2rem, 5vw, 3rem)",
            marginBottom: "1rem",
          }}
        >
          <FormattedMessage id="closed.title" defaultMessage="Portfolio closed" />
        </h1>

        <p
          style={{
            fontSize: "clamp(1rem, 3.5vw, 1.2rem)",
            margin: "0 auto",
          }}
        >
          <FormattedMessage
            id="closed.description"
            defaultMessage="This site is temporarily unavailable. The portfolio is not up to date and has been intentionally taken offline."
          />
        </p>

        <div style={{ marginTop: "2rem" }}>
          <a
            href="https://www.linkedin.com/in/marcos-gabriel-lorenzana-k2i5n1g8"
            target="_blank"
            rel="noreferrer"
            className="icon-colour home-social-icons"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "56px",
              height: "56px",
              borderRadius: "50%",
              fontSize: "1.6rem",
              color: "#c9d1d9",
              border: "1px solid #30363d",
              transition: "transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.08)";
              e.currentTarget.style.backgroundColor = "#0a66c2";
              e.currentTarget.style.borderColor = "#0a66c2";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.borderColor = "#30363d";
            }}
          >
            <FaLinkedinIn />
          </a>
        </div>

        <p style={{ marginTop: "1.5rem", fontSize: "0.9rem", opacity: 0.7 }}>
          <FormattedMessage id="closed.thanks" defaultMessage="Thank you for your interest." />
        </p>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="*" element={<Cerrado />} />
      </Routes>
    </Router>
  );
}

export default App;